const FEATURE = {
  FOOT: 'pedestrian',
  CAR: 'car',
  BUS: 'publicTransport',
  BIKE: 'bicycle',
}

export default FEATURE
